import { useDispatch } from 'react-redux';
import { useMapEvents } from 'react-leaflet';
import { mapViewChanged } from '../../store/slices/mapViewSlice';

/**
 * Remembers where the operator left the map (#441).
 *
 * Records the viewport on `moveend`/`zoomend` — after a gesture settles, not
 * continuously through it, so a pan is one action rather than one per frame.
 *
 * Restoring is not done here. `MapContainer` reads `center` and `zoom` only at
 * construction, and each view switch builds a new map, so the remembered
 * viewport is applied by seeding those props at mount — see `useInitialMapView`.
 *
 * Renders nothing; must live inside a `MapContainer`.
 */
export const MapViewMemory: React.FC = () => {
  const dispatch = useDispatch();

  useMapEvents({
    moveend(e) {
      const center = e.target.getCenter();
      dispatch(
        mapViewChanged({
          center: [center.lat, center.lng],
          zoom: e.target.getZoom(),
        })
      );
    },
    zoomend(e) {
      const center = e.target.getCenter();
      dispatch(
        mapViewChanged({
          center: [center.lat, center.lng],
          zoom: e.target.getZoom(),
        })
      );
    },
  });

  return null;
};
